import { render, staticRenderFns } from "./category_list.vue?vue&type=template&id=2e4f7e4a&scoped=true&"
import script from "./category_list.vue?vue&type=script&lang=js&"
export * from "./category_list.vue?vue&type=script&lang=js&"
import style0 from "./category_list.vue?vue&type=style&index=0&id=2e4f7e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f7e4a",
  null
  
)

export default component.exports